import { useStore } from "@features/common"
import { useAmp } from "next/amp"

import { SmartBanner } from "../organisms"

import type { SmartBannerProps } from "../organisms"

export function useSmartBanner(
  customData: Partial<SmartBannerProps["data"]> = {},
) {
  const { GlobalModel } = useStore()
  const isAMP = useAmp()
  const smartBanner = { ...GlobalModel.smartBanner, ...customData }

  const showSmartBanner =
    !GlobalModel.isSmartBannerDisabled &&
    GlobalModel.isSmartBannerOpened &&
    smartBanner.description &&
    smartBanner.buttonText &&
    smartBanner.playmarketButtonText &&
    smartBanner.appgalleryButtonText &&
    !isAMP

  return {
    smartBanner: showSmartBanner ? <SmartBanner data={smartBanner} /> : null,
  }
}
